import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { clearToast } from 'store/toast';

import { SnackWrapper } from './styles';
import { IToast } from './Toast';
import { ToastItem } from './ToastItem';

const contDownTime = 5000;
const maxSnacks = 3;
const direction = 'left' as IToast.TDirection;

export const Toast = () => {
  const [snackbars, setSnackbars] = useState<IToast.TQueueableToast[]>([]);
  const [queue, setQueue] = useState<IToast.TQueueableToast[]>([]);

  const enqueue = (snackbar: IToast.IToastItem) => {
    const id = new Date().getTime() + Math.random();

    if (snackbars.length >= maxSnacks) {
      dismissLast();
      setQueue((state) => state.concat({ ...snackbar, id, open: true }));
    } else {
      setSnackbars((state) => [{ ...snackbar, id, open: true }].concat(state));
      enqueueForDismiss(id, snackbar?.countdown);
    }
    return id;
  };

  function enqueueForDismiss(id: number, countdown: number = contDownTime) {
    setTimeout(() => {
      dismiss(id);
    }, countdown);
  }

  function dismiss(id: number) {
    setSnackbars((state) =>
      state.map((snack) => ({
        ...snack,
        open: snack.id === id ? false : snack.open,
      })),
    );
  }

  function dismissLast() {
    dismiss(snackbars[snackbars.length - 1].id);
  }

  const addNext = () => {
    if (queue.length) {
      const snack: IToast.TQueueableToast = queue[0];

      setQueue((state) => {
        state.shift();
        return state;
      });

      setSnackbars((state) => [{ ...snack }].concat(state));
      enqueueForDismiss(snack.id, snack?.countdown);
    }
  };

  const remove = (id: number) => {
    setSnackbars((state) => state.filter((snack) => snack.id !== id));
  };

  const toast = useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (toast.message) {
      enqueue({
        title: toast.title,
        message: toast.message,
        variant: toast.variant,
      });
    }
    return () => {
      dispatch(clearToast());
    };
  }, [toast, enqueue]);

  return (
    <div>
      {!!snackbars.length && (
        <SnackWrapper direction={direction}>
          {snackbars.map((snack) => {
            const { ...rest } = snack;
            return (
              <ToastItem
                {...rest}
                key={snack.id}
                onDismiss={() => dismiss(snack.id)}
                direction={direction || 'left'}
                onClose={() => {
                  remove(snack.id);
                  addNext();
                }}
                countdown={snack.countdown ? snack.countdown : contDownTime}
              />
            );
          })}
        </SnackWrapper>
      )}
    </div>
  );
};
